import React from "react";
import mainLogog from "../../images/bannersectionImages/mainLogo.svg"
import { HeaderStyle } from "./style";
const HeaderSection = () => {
  return (
    <HeaderStyle>
     <header>
      <div className="container">
        <nav className="navba">
          <div className="navLogo">
          <a className="navbar-brand" href="#">
            <img src={mainLogog} alt="image" className=""/>
          </a>
          </div>
         
        </nav>
      </div>
    </header>
    </HeaderStyle>
   
  );
};

export default HeaderSection;
